import React, {useContext, useState} from 'react'
import PatientListPageTemplate from '../../../components/Templates/PatientListPageTemplate'
import OrgPatientListStore from '../../../components/Modals/PrintModal/store/OrgPatientListStore'
import { observer } from 'mobx-react'
import LinkCell3 from '../../../components/Pages/TablePage/Table/Cells/LinkCell3/LinkCell3'
import ModalsStore from '../../../components/Pages/Modals.store'
import { useAPI } from '../../../hooks/useAPI'
import { MedCenter_API } from '../MedCenter_API'
import {AuthContext} from "../../../context/AuthContext";
import {formatDate, isWaiting} from "../../../utils/utils";
import IconCell from "../../../components/Pages/TablePage/Table/Cells/NewCells/IconCell/IconCell";

const AllPatientList = observer(() => {

  const [refresh, setRefresh] = useState()
  const { APIRequest } = useAPI()
  const { token } = useContext(AuthContext)


  return (
    <PatientListPageTemplate
      refresh={refresh}
      getPatientURL={`/api/v2/medCenters/${token.userId}/patients?`}
      tableModel={{
        firstRow: [
          { title: 'ФИО', id: 'fio' },
          { title: 'Дата рождения', id: 'resultDate' },
          { title: 'Мед. книжка', id: 'medBook' },
          { title: 'Организация', id: 'organization' },
          { title: 'Дата прохождения', id: 'resultDate' },
          { title: 'Результат', id: '' },
          { title: 'Распечатать', id: '' }],
        haveToShow: [
          {
            type: 'wrapperCell', typeData: {
              cell: props =>
                <LinkCell3 linkTitle={props.all.patients.fio}
                           editClick={_ => ModalsStore.showModal('EditPatient2',
                             {
                               disabledFields: {
                                 fio: true,
                                 dob: true,
                                 phone: true,
                                 address: true,
                                 jobName: true,
                                 medCenter: true,
                                 organization: true
                               },
                               initialForm: {
                                 med_book: props.all?.patients?.med_book,
                                 resultId: props.all?.id
                               }
                             },
                             {
                               closeHandler() {
                                 setRefresh(!refresh)
                               },
                               submit: async (formData) => {
                                 return await APIRequest(MedCenter_API.allPatients.updatePatient(token.userId , props.all.patients.id), formData)
                                   .then(response => response?.status === 200 ? 'success' : 'error')
                               }
                             }
                           )} />
            }
          },
          { id: 'patients', type: 'arrCell', typeData: { show: 'dob', id: 'id' } },
          { id: 'patients', type: 'arrCell', typeData: { show: 'med_book', id: 'id' } },
          { id: 'verificationcenter', type: 'arrCell', typeData: { show: 'name', id: 'id' } },
          { id: 'results', type: 'wrapperCell', typeData: { cell: props => <LinkCell3 linkTitle={formatDate(props?.all?.results?.result_date)}/> } },
          { id: 'results', type: 'resultStatusCell', typeData: { show: 'result', id: 'patient_id' } },
            {
                typeData: {
                    cell: props =>  !isWaiting(props?.all?.results?.result) ? <IconCell iconName={"printer"} onClick={() => OrgPatientListStore.showPrintModal(props?.all?.results?.id, props?.all?.patients?.id)}/> : "",
                },
                type: 'wrapperCell'
            }
        ]
      }}
      filterFieldsConf={{
        fio: true,
        date: true,
        period: true,
        result: true,
        medBook: true
      }}
      registry={false}
      breadCrumbsItems={[
        { title: 'Пациенты' },
        { title: 'Все', actual: true }
      ]}
      exportUrl={`/api/v1/organizations/patients/export/excel?`} />
  )
})

export default AllPatientList
